import React, { useState } from "react";
import { AlertCircle, CheckCircle2, XCircle } from "lucide-react";
import { useDeleteCategoryMutation } from "../../services/categories/categoriesApi";
import useClickOutsideModal from "../common/useClickOutsideModal";
import { showToast } from "../../utils/toast";

const DeleteCategoryModal = ({ isOpen, onClose, category, onDeleted }) => {
  const [deleteCategory, { isLoading }] = useDeleteCategoryMutation();

  const handleDelete = async () => {
    const categoryId = category?._id || category?.id;

    if (!categoryId) {
     showToast({
      message: "Category id is missing.",
      type: "error",
    });
    return;
    }

    try {
      
      await deleteCategory(categoryId).unwrap();
      showToast({
      message: "Category deleted successfully.",
      type: "success",
    });

    if (typeof onDeleted === "function") {
      onDeleted();
    }

    onClose()
    } catch (error) {
        showToast({
      message:
        error?.data?.message || "Unable to delete category.",
      type: "error",
    });
  };
  }

    const modalRef = useClickOutsideModal(onClose);
  

  if (!isOpen || !category) {
    return null;
  }

  const linkedCourses = category.subCategory.length;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-black/55 px-4 py-8">
      <div ref={modalRef} className="w-full max-w-[448px] overflow-hidden rounded-lg bg-white">
        <div className="border-b border-[#E5E7EB] p-6">
          <div className="flex items-start gap-4">
            <span
              className={`inline-flex h-12 w-12 items-center justify-center rounded-full   bg-[#FEE2E2] text-[#DC2626] `}
            >
            
                <CheckCircle2 size={22} strokeWidth={2.5} />
              
            </span>
            <div>
              <h3 className="text-lg font-semibold text-[#111827]">
               
                  Delete Category
              </h3>
              <p className="text-sm text-[#6B7280]">
               This action cannot be undone
              </p>
            </div>
          </div>
        </div>

          <div className="border-b border-[#E5E7EB] p-6">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#923D8C20] text-[#923D8C]">
                {category.icon ? (
                  <img
                    src={category.icon.secureUrl}
                    alt={`${category.categoryName} icon`}
                  />
                ) : null}
              </span>
              <div>
                <p className="font-medium text-[#111827]">
                  {category.categoryName}
                </p>
                <p className="text-sm text-[#6B7280]">
                  {linkedCourses} subcategories
                </p>
              </div>
            </div>

            <div className="mt-4 rounded-lg border border-[#FECACA] bg-[#FEF2F2] p-4 text-[#991B1B]">
              <p className="text-sm">
                <span className="font-bold">Warning:</span> Deleting this
                category will remove all its subcategories and linked courses.
                Are you sure you want to proceed?
              </p>
            </div>

            <div className="mt-4">
              <p className="text-sm text-[#4B5563]">
                This will permanently delete:
              </p>
              <ul className="mt-2 list-disc pl-6 text-[#4B5563]">
                <li>{linkedCourses} subcategories</li>
                <li>All associated data and settings</li>
              </ul>
            </div>
          </div>
        

        <div className="p-6">
          <div className="flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={() => onClose()}
              className="rounded-lg bg-[#F3F4F6] px-4 py-2 text-base  text-[#374151]"
            >
             
                Cancel
            </button>
              <button
                type="button"
                onClick={handleDelete}
                disabled={isLoading}
                className="rounded-lg bg-[#DC2626] px-6 py-2 text-base text-white disabled:cursor-not-allowed disabled:opacity-70"
              >
                {isLoading ? "Deleting..." : "Delete Category"}
              </button>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteCategoryModal;
